<template>
  <section class="page-notfound">
    <van-empty :description="$t('views.404.941392-0')" />
  </section>
</template>
<script>
export default {
  /******************************************
  ** 404
  * @description 404
  * @author stone
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: '404',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.page-notfound {
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  justify-content: center;
  align-items: center;
}
</style>
